import { render, staticRenderFns } from "./TicketFeedbackReview.vue?vue&type=template&id=84a9a510&"
import script from "./TicketFeedbackReview.vue?vue&type=script&lang=ts&"
export * from "./TicketFeedbackReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports